import {
  Box,
  Flex,
  Link,
  Image,
  Theme,
  Icon,
  IconButton,
  Stack,
} from "@chakra-ui/react";

import {
  DrawerActionTrigger,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerRoot,
  DrawerTrigger,
} from "../ui/drawer";
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from "../ui/menu";
import { Link as RouterLink } from "react-router-dom";

import { useEffect, useState } from "react";
import SingleMenuItem from "./SingleMenuItem";
import { ColorModeButton, useColorModeValue } from "../ui/color-mode";
import { MdKeyboardArrowDown } from "react-icons/md";
import { CgMenuRight } from "react-icons/cg";
import { RiCustomerService2Fill } from "react-icons/ri";
import { FaIndianRupeeSign } from "react-icons/fa6";

import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from "../ui/accordion";
import { FaCircleArrowRight } from "react-icons/fa6";

const Header = () => {
  const logo = useColorModeValue("../assets/logo.png", "../assets/logo1.png");
  const hovercolor = useColorModeValue("#008080", "#66b2b2");
  const headerBg = useColorModeValue("#F6FAFF", "#090110");
  const borderBottom = useColorModeValue(
    "1px solid #b8fff7",
    "1px solid #24243e"
  );

  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Flex
        as="header"
        justifyContent="space-between"
        alignItems="center"
        wrap="wrap"
        py="2"
        px={{ base: "4", md: "5", lg: "10" }}
        w="full"
        pos="fixed"
        zIndex="9999"
        top="0"
        left="0"
        // bg={{ base: "transparent", _dark: "#05051e" }}
        bgColor={isScrolled && !open ? headerBg : "transparent"}
        borderBottom={isScrolled ? borderBottom : "none"}
        transition="all 0.3s ease-in-out"
      >
        {/* Logo */}
        <Link
          as={RouterLink}
          to="/"
          color="whiteAlpha.800"
          fontWeight="bold"
          letterSpacing="wide"
          _hover={{ textDecor: "none", color: "white" }}
          px="2"
          onClick={() => {
            window.scrollTo({ top: "0", behavior: "smooth" });
          }}
          _focus={{ outline: "none" }}
        >
          <Image
            objectFit="fill"
            w={{ base: "150px", md: "200px", lg: "200px" }}
            src={logo}
            alt="logo"
          />
        </Link>

        {/* Links */}
        <Box
          display={{ base: "none", md: "flex" }}
          width={{ base: "full", md: "300px", lg: "400px" }}
          justifyContent="space-evenly"
        >
          <SingleMenuItem label="ABOUT US" url="/about" />

          {/* SERVICES */}
          <MenuRoot>
            <MenuTrigger asChild>
              <Link
                fontSize={{ base: "xl", md: "xs", lg: "sm" }}
                letterSpacing="wide"
                display="flex"
                alignItems="center"
                fontWeight="600"
                _hover={{ textDecor: "none", color: hovercolor }}
                _focus={{ outline: "none" }}
              >
                SERVICES <MdKeyboardArrowDown size={20} />
              </Link>
            </MenuTrigger>
            <MenuContent bgColor={{ base: "white", _dark: "#1a1625" }}>
              <MenuItem value="ITR Filing">
                <SingleMenuItem w="full" label="ITR Filing" url="/itr-filing" />
              </MenuItem>
              <MenuItem value="GST Filing">
                <SingleMenuItem w="full" label="GST Filing" url="/gst-filing" />
              </MenuItem>
              <MenuItem value="Business Registration">
                <SingleMenuItem
                  w="full"
                  label="Business Registration"
                  url="/business-registration"
                />
              </MenuItem>
              <MenuItem value="Expert CA Assistance">
                <SingleMenuItem
                  w="full"
                  label="Expert CA Assistance"
                  url="/expert-assistance"
                />
              </MenuItem>
            </MenuContent>
          </MenuRoot>

          <SingleMenuItem label="CONTACT" url="/contact" />
        </Box>

        <Flex
          gap={3}
          display={{ base: "none", md: "flex" }}
          alignItems="center"
        >
          {/* <SimpleOutlineButton
            title="Lets Connect"
            size={{ sm: "xs", md: "sm", lg: "md" }}
          /> */}

          {/* Payment Icon */}
          <Link
            as={RouterLink}
            to="/payments"
            onClick={() => {
              window.scrollTo({ top: "0", behavior: "auto" });
            }}
          >
            <IconButton
              variant="outline"
              borderRadius="full"
              bgColor={hovercolor}
              color={headerBg}
              _hover={{
                boxShadow:
                  "rgba(138, 158, 241, .15) 0 2px 4px, rgba(138, 158, 241, .15) 0 4px 8px, rgba(138, 158, 241, .15) 0 6px 12px",
                transform: "scale(1.01)",
              }}
            >
              <FaIndianRupeeSign />
            </IconButton>
          </Link>

          {/* Contact Icon */}
          <Link as={RouterLink} to="tel:+91-9876543210">
            <IconButton
              variant="outline"
              borderRadius="full"
              color={hovercolor}
              _hover={{
                boxShadow:
                  "rgba(138, 158, 241, .15) 0 2px 4px, rgba(138, 158, 241, .15) 0 4px 8px, rgba(138, 158, 241, .15) 0 6px 12px",
                transform: "scale(1.01)",
              }}
            >
              <RiCustomerService2Fill />
            </IconButton>
          </Link>

          {/* Color Mode Button */}
          <ColorModeButton
            borderRadius="full"
            color={hovercolor}
            _hover={{
              boxShadow:
                "rgba(138, 158, 241, .15) 0 2px 4px, rgba(138, 158, 241, .15) 0 4px 8px, rgba(138, 158, 241, .15) 0 6px 12px",
              transform: "scale(1.01)",
            }}
          />
        </Flex>

        {/* Mobile Drawer */}
        <Flex display={{ base: "flex", md: "none" }} gap={2}>
          {/* Rupee */}
          <Link
            as={RouterLink}
            to="/payments"
            onClick={() => {
              window.scrollTo({ top: "0", behavior: "auto" });
            }}
          >
            <IconButton
              variant="outline"
              borderRadius="full"
              color={hovercolor}
              display={open ? "none" : "flex"}
              size="sm"
              _hover={{
                boxShadow:
                  "rgba(138, 158, 241, .15) 0 2px 4px, rgba(138, 158, 241, .15) 0 4px 8px, rgba(138, 158, 241, .15) 0 6px 12px",
                transform: "scale(1.01)",
              }}
            >
              <FaIndianRupeeSign />
            </IconButton>
          </Link>
          {/* <ColorModeButton /> */}
          <ColorModeButton
            borderRadius="full"
            color={hovercolor}
            display={open ? "none" : "flex"}
            _hover={{
              boxShadow:
                "rgba(138, 158, 241, .15) 0 2px 4px, rgba(138, 158, 241, .15) 0 4px 8px, rgba(138, 158, 241, .15) 0 6px 12px",
              transform: "scale(1.01)",
            }}
          />
          <DrawerRoot
            size="full"
            open={open}
            onOpenChange={(e) => setOpen(e.open)}
          >
            <DrawerTrigger asChild>
              <IconButton
                bgColor="transparent"
                color={hovercolor}
                display={open ? "none" : "block"}
              >
                <Icon boxSize="7">
                  <CgMenuRight />
                </Icon>
              </IconButton>
            </DrawerTrigger>
            <DrawerContent bgColor={headerBg}>
              <DrawerBody mt={28}>
                <Flex direction="column" gap={10}>
                  <DrawerActionTrigger>
                    <SingleMenuItem label="HOME" url="/" />
                  </DrawerActionTrigger>
                  <DrawerActionTrigger>
                    <SingleMenuItem label="ABOUT" url="/about" />
                  </DrawerActionTrigger>
                  {/* SERVICES */}
                  <AccordionRoot collapsible w="fit-content">
                    <AccordionItem borderColor="transparent" value="a">
                      <AccordionItemTrigger
                        fontSize={{ base: "xl", md: "xs", lg: "sm" }}
                        letterSpacing="wide"
                        fontWeight="600"
                      >
                        SERVICES
                      </AccordionItemTrigger>
                      <AccordionItemContent>
                        <DrawerActionTrigger>
                          <Stack gap={6} p={2} pl={5}>
                            <SingleMenuItem
                              label="ITR Filing"
                              url="/itr-filing"
                              fontSize="md"
                            />
                            <SingleMenuItem
                              label="GST Filing"
                              url="/gst-filing"
                              fontSize="md"
                            />
                            <SingleMenuItem
                              label="Business Registration"
                              url="/business-registration"
                              fontSize="md"
                            />
                            <SingleMenuItem
                              label="Expert CA Assistance"
                              url="/expert-assistance"
                              fontSize="md"
                            />
                          </Stack>
                        </DrawerActionTrigger>
                      </AccordionItemContent>
                    </AccordionItem>
                  </AccordionRoot>

                  <DrawerActionTrigger>
                    <SingleMenuItem label="CONTACT" url="/contact" />
                  </DrawerActionTrigger>
                  <DrawerActionTrigger>
                    <SingleMenuItem
                      label="LETS CONNECT"
                      icon={<FaCircleArrowRight />}
                      url="/contact"
                    />
                  </DrawerActionTrigger>
                  <DrawerActionTrigger>
                    <SingleMenuItem
                      label="PAY NOW"
                      icon={<FaCircleArrowRight />}
                      url="/payments"
                    />
                  </DrawerActionTrigger>
                </Flex>
              </DrawerBody>
              <Theme appearance="dark">
                <DrawerCloseTrigger color={hovercolor} pb="3" />
              </Theme>
            </DrawerContent>
          </DrawerRoot>
        </Flex>
      </Flex>
    </>
  );
};

export default Header;
